/* eslint-disable */
import { script } from '@didi/utils'

const _wxSDK = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
const jsApiTicketUrl = '//common.diditaxi.com.cn/webapp/platform/jsapiticket'

let scriptFinish = null
let _wx

export function loadWxScript() {
  scriptFinish = scriptFinish || script.loadScript(_wxSDK)
}

export async function weixinReady() {
  if (!scriptFinish) {
    loadWxScript()
  }
  await scriptFinish
  if (!_wx) {
    _wx = new Promise(function (resolve, reject) {
      const url = window.location.href.split('#')[0]
      const OneTravel = ''

      var xhr = new XMLHttpRequest()
      xhr.open(
        'POST',
        jsApiTicketUrl,
        false
      )
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText)
            const data = response.data
            const config = {
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: ['checkJsApi', 'updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline']
            }
            global.wx.config(config)
            global.wx.ready(function () {
              console.log('ok')
              resolve(global.wx)
            })
            global.wx.error(function (error) {
              console.log('config-error:', error)
              reject(error)
            })
          } catch (error) {
            console.log('ajax-err:', error)
            reject(error)
          }
        }
      }
      const ot = encodeURIComponent(encodeURIComponent(encodeURIComponent(OneTravel)))
      const u = url.replace(/OneTravel=\S+/, `OneTravel=${ot}`)
      xhr.send(`url=${encodeURIComponent(u)}&srvno=didichuxing&source=weixin`)
    })
  }
  return _wx
}
